import axios from './financeiroApi';

const PATH = '/api/v1/backend/banco';

const bancoApi = {
  get: () => axios.get(`${PATH}?size=300`),
  pesquisarPorNomeECodigo: (params) => axios.get(`${PATH}/pesquisar`, { params }),
};

export { bancoApi };
